export default __webpack_public_path__ + "static/media/img5.0e0d55e3.svg";